module.exports = __webpack_public_path__ + "img/timekeeper_wert.cc0c76d7.svg";